export default __webpack_public_path__ + "static/media/p2p.97e3daac.png";